<template>
  <div class="tw:sm:mx-4 tw:lg:mx-0 tw:w-full">
    <div v-if="isCompetitivenessStatsLoading" class="tw:rounded-xl tw:animate-pulse tw:bg-gray-300 tw:h-[658px]"></div>
    <div v-else-if="isCompetitivenessStatsError">
      <p class="tw:text-center tw:text-xl">{{ $t('onboarding.appLaunchError.header') }}</p>
    </div>

    <OpportunityAreaWrapper v-else :impressions="impressions" />
    <FullScreenLoader v-show="requiredDataIsBeingRefetched" />
  </div>
</template>

<script setup lang="ts">
import { computed, type ComputedRef } from 'vue'

import { useExpectedTopShare, useCampaign, useCompetitivenessStats } from '@/components/rateConnect/queries'
import { selectedAccommodationId } from '@/layouts/queries'

import OpportunityAreaWrapper from '@/components/rateConnect/opportunityArea/OpportunityAreaWrapper.vue'
import FullScreenLoader from '@/components/base/loaders/FullScreenLoader.vue'

const {
  competitivenessStats,
  isLoading: isCompetitivenessStatsLoading,
  isFetching: isCompetitivenessStatsFetching,
  isError: isCompetitivenessStatsError,
} = useCompetitivenessStats(selectedAccommodationId)

const { currentCommissionLevel } = useCampaign(selectedAccommodationId)
const { isFetching: isExpectedTopShareFetching } = useExpectedTopShare(currentCommissionLevel)

const requiredDataIsBeingRefetched: ComputedRef<boolean> = computed(
  () =>
    !isCompetitivenessStatsLoading.value && (isExpectedTopShareFetching.value || isCompetitivenessStatsFetching.value)
)

const impressions: ComputedRef<number | undefined> = computed(() => competitivenessStats.value?.hotelImpressions)
</script>
